/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MediaAudioVolumeSPlusIcon16Light } from './MediaAudioVolumeSPlusIcon16Light';
import { MediaAudioVolumeSPlusIcon16Regular } from './MediaAudioVolumeSPlusIcon16Regular';
import { MediaAudioVolumeSPlusIcon16Solid } from './MediaAudioVolumeSPlusIcon16Solid';
import { MediaAudioVolumeSPlusIcon20Light } from './MediaAudioVolumeSPlusIcon20Light';
import { MediaAudioVolumeSPlusIcon20Regular } from './MediaAudioVolumeSPlusIcon20Regular';
import { MediaAudioVolumeSPlusIcon20Solid } from './MediaAudioVolumeSPlusIcon20Solid';
import { MediaAudioVolumeSPlusIcon24Regular } from './MediaAudioVolumeSPlusIcon24Regular';
import { MediaAudioVolumeSPlusIcon24Solid } from './MediaAudioVolumeSPlusIcon24Solid';
import { MediaAudioVolumeSPlusIcon32Regular } from './MediaAudioVolumeSPlusIcon32Regular';
import { MediaAudioVolumeSPlusIcon64Regular } from './MediaAudioVolumeSPlusIcon64Regular';
var sizes = {
    16: {
        light: MediaAudioVolumeSPlusIcon16Light,
        regular: MediaAudioVolumeSPlusIcon16Regular,
        solid: MediaAudioVolumeSPlusIcon16Solid,
    },
    20: {
        light: MediaAudioVolumeSPlusIcon20Light,
        regular: MediaAudioVolumeSPlusIcon20Regular,
        solid: MediaAudioVolumeSPlusIcon20Solid,
    },
    24: {
        regular: MediaAudioVolumeSPlusIcon24Regular,
        solid: MediaAudioVolumeSPlusIcon24Solid,
    },
    32: {
        regular: MediaAudioVolumeSPlusIcon32Regular,
    },
    64: {
        regular: MediaAudioVolumeSPlusIcon64Regular,
    },
};
export var MediaAudioVolumeSPlusIcon = forwardRef('MediaAudioVolumeSPlusIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
